<template>
  <div class="content campaigns-wrap">
    <div class="page-header" :class="{'header-hidden': !isScrollTop}">
      <div class="flex px-4 md:block">
        <div class="w-72 lg:w-60 mx-4 mt-4 md:hidden">
          <img class="mt-3" :src="require('./events-illustration.svg')" width="290px" />
        </div>

        <div class="mt-6 lg:mt-4">
          <!--          <pre>{{eventsInfo}}</pre>-->
          <div class="font-semibold text-3xl md:text-xl">Events & Tickets</div>
          <p class="md:hidden">Create and manage your organization's upcoming events and tickets</p>
          <div v-if="eventsList !== null" class="flex justify-between mt-6 lg:mt-3">
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">{{ eventsInfo.ongoing }}</span>
              <div class="md:text-sm mt-2">Upcoming</div>
            </div>
            <div class="text-center px-3">
              <span class="font-black text-4xl md:text-xl">{{ eventsInfo.past }}</span>
              <div class="md:text-sm mt-2">Past Events</div>
            </div>
            <div class="text-center" style="min-width: 150px">
              <span class="font-black text-4xl md:text-xl">${{ eventsInfo.revenue / 100 | formatMoney }}</span>
              <div class="md:text-sm mt-2">Total Revenue</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flex justify-between md:items-center md:flex-col-reverse bg-white shadow-sm px-8 py-3 lg:px-4">
      <div>
        <el-dropdown trigger="click" @command="updateSorting">
          <el-button size="medium"><b>{{ selectedSorting.title }}</b>
            <font-awesome-icon class="ml-4 text-xs text-gray-400" :icon="['far', 'chevron-down']" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in sortOptions" :key="item.key" :command="item">{{ item.title }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="flex-grow md:mb-4 text-right mr-4 lg:mr-2 md:mr-0">
        <el-radio-group v-model="selectedFilter" size="medium">
          <el-radio-button label="ongoing">Upcoming</el-radio-button>
          <el-radio-button label="ended">Past</el-radio-button>
          <el-radio-button label="archived">Archived</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </div>

      <div class="md:mb-4 sm:w-full">
        <div class="inline-block sm:w-4/5 mr-4 lg:mr-2">
          <el-input v-model="searchFilter" size="medium" placeholder="Search" class="max-w-xs">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>

        </div>

        <el-button type="primary" size="medium" v-on:click.prevent="$router.push({name: 'eventAdd'});">
          <font-awesome-icon class="mr-2 lg:mr-0 text-xs leading-2" :icon="['fas', 'plus']" />
          <span class="lg:hidden">New Event</span>
        </el-button>
      </div>

    </div>

    <transition-group v-if="eventsList && eventsList.length > 0" name="cmp-list" tag="div" class="list-campaigns"
      :class="{'list-campaigns-open': isScrollTop}">


      <EventCard v-for="event in eventsListFiltered" :key="`event_${event.id}`" @command="handleCommand"
        :event="event" />
    </transition-group>
    <div v-if="eventsList && eventsList.length < 1" class="empty-placeholder mt-0" key="no-events">
      <img :src="require('../../assets/paceholders/36.svg')" alt="No results">
      <h3>No Events Yet</h3>
    </div>
    <div v-if="!eventsList" class="empty-placeholder mt-0" key="no-events">
      <img :src="require('../../assets/paceholders/8.svg')" alt="No results">
      <h3>Loading Events...</h3>
    </div>

    <archive-event-modal :visible.sync="isArchiveModal" :activeEvent="activeEvent"
      v-on:archived="isArchiveModal = false; loadEvents();"></archive-event-modal>

  </div>
</template>


<script>
import { EventsTickets } from "@/utils/api";
import CmpProgress from "@/components/Campaigns/progress";
import scrollInfoMixin from '../../mixins/scroll-info-mixin';
import ArchiveEventModal from './archive-event-modal';
import EventProgress from './progress';
import { mapState } from "vuex";
import config from "../../../public/harness_config.json";
import EventCard from "./event-card";

const moment = require('moment-timezone');

export default {
  name: "events-list",
  metaInfo: {
    title: 'Events',
  },
  mixins: [scrollInfoMixin],
  mounted() {
    this.loadEvents();
  },
  components: {
    CmpProgress,
    ArchiveEventModal,
    EventProgress,
    EventCard,
  },
  methods: {
    sortEvents(eventsList, type, decending = false) {
      switch (type) {
        case "alphabetical":
          if (decending) {
            return [...eventsList].sort((e1, e2) => e2.name.localeCompare(e1.name));
          }
          return [...eventsList].sort((e1, e2) => e1.name.localeCompare(e2.name));

        case "date_created":
          if (decending) {
            return [...eventsList].sort((e1, e2) => {
              return (new Date(e1.createdAt)).valueOf() - (new Date(e2.createdAt)).valueOf();
            });
          }
          return [...eventsList].sort((e1, e2) => {
            return (new Date(e2.createdAt)).valueOf() - (new Date(e1.createdAt)).valueOf();
          });

        case "date_time":
        default:
          if (decending) {
            return [...eventsList].sort((e1, e2) => {
              return (new Date(e1.startDate)).valueOf() - (new Date(e2.startDate)).valueOf();
            });
          }
          return [...eventsList].sort((e1, e2) => {
            return (new Date(e2.startDate)).valueOf() - (new Date(e1.startDate)).valueOf();
          });
      }
    },
    handleCommand([command, payload]) {
      switch (command) {
        case 'edit':
          this.$router.push({ name: 'eventEdit', params: { 'eventId': payload.id } });
          break
        case 'view-tickets':
          this.$router.push({ name: 'event-tickets', params: { 'eventId': payload.id } });
          break
        case 'duplicate':
          // eslint-disable-next-line no-console
          console.log('duplicate');
          break
        // case 'unarchive':
        //   this.unrchiveCampaign(payload);
        //   break
        case 'archive':
          this.isArchiveModal = true;
          this.activeEvent = payload;
          break
        case 'view-details':
          this.$router.push({ name: 'event', params: { 'eventId': payload.id } });
          break
        case 'event-page':
          window.open(`${this.config.donor_next_scheme}://${this.activeCharityInfo.subdomain}.${this.config.donor_next_url}/events/${payload.id}`);
          break
      }
    },
    loadEvents() {
      EventsTickets.getEventsList(this.activeCharityId).then(events => {

        this.eventsList = Object.values(events.events)
        this.$nextTick(() => {
          this.initScrollInfo(['.list-campaigns']);
        });
      }).catch(() => this.eventsList = []);
    },
    updateSorting(newSorting) {
      this.selectedSorting = newSorting;
    },
  },
  computed: {
    eventsInfo() {
      let info = {
        'ongoing': 0,
        'past': 0,
        'revenue': 0
      };
      if (this.eventsList && this.eventsList.length) {
        info.ongoing = this.eventsList.filter(eventItem => moment(eventItem.startDate) >= moment()).length;
        info.past = this.eventsList.filter(eventItem => moment(eventItem.startDate) < moment()).length;
        info.revenue = this.eventsList.reduce((res, eventItem) => res + (eventItem.stock && eventItem.stock.revenue && parseFloat(eventItem.stock.revenue) || 0), 0);
      }

      return info;
    },
    eventsListFiltered() {
      if (!this.eventsList) {
        return [];
      }
      let eventsList = JSON.parse(JSON.stringify(this.eventsList));


      if (this.searchFilter !== '') {
        let re = new RegExp(this.searchFilter, 'ig');
        eventsList = eventsList.filter(eventItem => eventItem.name.search(re) !== -1);
      }

      if (this.selectedFilter === 'ongoing') {
        eventsList = eventsList.filter(eventItem => moment(eventItem.endDate) >= moment() && eventItem.state !== 'archived');
      } else if (this.selectedFilter === 'ended') {
        eventsList = eventsList.filter(eventItem => moment(eventItem.endDate) < moment() && eventItem.state !== 'archived');
        if (this.selectedSorting.key === 'date_time') {
          return this.sortEvents(eventsList, this.selectedSorting.key, false);
        }
      } else if (this.selectedFilter === 'archived') {
        eventsList = eventsList.filter(eventItem => eventItem.state === 'archived');
      } else {
        if (this.selectedSorting.key === 'date_time') {
          return this.sortEvents(eventsList, this.selectedSorting.key, false);
        }
      }

      return this.sortEvents(eventsList, this.selectedSorting.key, this.selectedSorting.decending);
    },
    ...mapState({
      activeCharityId: state => state.auth.activeCharityId,
      activeCharityInfo: state => state.charities.activeCharityInfo,
    }),
    config() {
      return config;
    },
  },
  watch: {
    'activeCharityId'() {
      this.eventsList = null;
      this.loadEvents();
    },
  },

  data() {
    return {
      eventsList: null,
      sortOptions: [
        { key: 'date_time', title: 'Date & Time', decending: true },
        { key: 'alphabetical', title: 'Alphabetical' },
        { key: 'date_created', title: 'Date Created' },
      ],
      selectedSorting: { key: 'date_time', title: 'Date & Time', decending: true },

      selectedFilter: 'ongoing',
      activeEvent: null,
      searchFilter: '',
      isArchiveModal: false,
    };
  },
}
</script>

<style lang="scss">
.cmp-list-move {
  transition: transform .5s;
}
</style>
<style lang="sass" scoped>
.campaigns-wrap
  .select-add-new
    width: 165px

    .icon-wrap
      display: inline-block
      width: 16px

  .donors-panel
    .col-sm-5
      i
        font-style: normal

    .btn-plus
      max-width: 136px
      padding: 9px 10px 8px 26px

    .search
      margin: 0 15px
      font-weight: 600
      font-size: 14px

    ::-webkit-input-placeholder
      color: rgb(53, 64, 82)
      opacity: 0.5
      font-weight: 600
      font-size: 14px
      font-family: var(--main-font-family)

    ::-moz-placeholder
      color: rgb(53, 64, 82)
      opacity: 0.5
      font-weight: 600
      font-size: 14px
      font-family: var(--main-font-family)

    -ms-input-placeholder
      color: rgb(53, 64, 82)
      opacity: 0.5
      font-weight: 600
      font-size: 14px
      font-family: var(--main-font-family)

  .list-campaigns
    overflow-y: auto
    transition: all .5s ease-in-out

    &.list-campaigns-open
      height: calc(100vh - 314px)

</style>

